import React from 'react';
import styled from 'styled-components';
import compose from 'lodash/fp/compose';
import { getIn } from 'seamless-immutable';
import { withRouter } from 'react-router';
import { withConfig } from '@catalogo/core-connect/config';
import { withCookies } from '@catalogo/core-connect/cookies';
import { withPaymentOption } from '@catalogo/service-americanas-product/src/payment';
import { formatPrice } from '@catalogo/core-helpers/price';
import BuyAme from '@catalogo/ui-americanas-mobile-buy-ame';
import WeddingList from '@catalogo/ui-americanas-mobile-wedding-list';
import BestPrice from '@catalogo/ui-americanas-mobile-best-price';
import PaymentOption from '@catalogo/ui-americanas-mobile-payment-option';
import BuyButton from '@catalogo/ui-americanas-mobile-buy-button';

const renderSecondaryButton = (enableAme, isWeddingList, currentSku, customer, history) => {
  if (isWeddingList) {
    return <WeddingList currentSku={currentSku} />;
  }

  return enableAme && <BuyAme fullWidth={false} customer={customer} history={history} />;
};

const renderPrice = (international, prime, mainPayment, defaultPrice, buyTogether) => {
  if (buyTogether) {
    return (
      <PriceArea>
        <Price>{`R$ ${formatPrice(buyTogether)}`}</Price>
        <Label>com item sugerido</Label>
      </PriceArea>
    );
  }

  return (
    <PriceArea>
      <BestPrice
        international={international}
        prime={prime}
        payment={mainPayment}
        defaultPrice={defaultPrice}
        isFloating
      />
      <PaymentOption payment={mainPayment} isFloating />
    </PriceArea>
  );
};

export const FloatAreaButton = ({
  buyTogether,
  defaultPrice,
  mainPayment,
  prime,
  international,
  currentSku,
  productId,
  customer,
  cookies,
  config,
  history,
  isPreSale,
  isO2O,
  enableAme,
  experiment,
  discountProgressiveExperiment,
  servicePDPinfoForWarranty,
}) => {
  const offer = getIn(currentSku, ['offers', 'result', '0']);
  const isB2WSeller = getIn(offer, ['seller', 'id']) === config.sellerId;
  const isWeddingList = !!getIn(cookies, ['listId'], '') && isB2WSeller;
  const hasSecondButton = enableAme || isWeddingList;

  if (!offer) {
    return null;
  }

  return (
    <Container>
      {renderPrice(international, prime, mainPayment, defaultPrice, buyTogether)}
      <ButtonArea>
        {renderSecondaryButton(enableAme, isWeddingList, currentSku, customer, history)}
        <BuyButton
          fullWidth={!hasSecondButton}
          isO2O={isO2O}
          productId={productId}
          currentSku={currentSku}
          isPreSale={isPreSale}
          experiment={experiment}
          discountProgressiveExperiment={discountProgressiveExperiment}
          servicePDPinfoForWarranty={servicePDPinfoForWarranty}
        />
      </ButtonArea>
    </Container>
  );
};

const Flex = styled.div`
  display: flex;
`;

const PriceArea = styled(Flex)`
  padding: 10px 20px 0;
  flex-direction: column;
`;

const Price = styled.div`
  font-size: 30px;
  line-height: 1.2;
  font-weight: 600;
  text-align: left;
  line-height: normal;
  margin: 0px;
`;

const Label = styled.div`
  padding-bottom: 20px;
`;

const ButtonArea = styled(Flex)`
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  margin: 10px 5px 15px;
`;

const Container = styled(Flex)`
  flex-direction: column;
  background: #fff;
  border-top: 1px solid #d3d2d2;
  box-shadow: 0px -2px 12px -2px #d3d2d2;
  bottom: 0;
  left: 0;
  position: fixed;
  width: 100%;
  z-index: 20;
`;

export default compose(withCookies, withConfig, withRouter, withPaymentOption)(FloatAreaButton);
